import React, { useEffect, useState } from "react";
import WorkflowSidebar from "../Components/WorkflowSidebar";
import { Box } from "@mui/material";
import "./Workflow.css";
import { useParams } from "react-router-dom";
import WorkflowDetails from "../Components/workflowDetails";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { useGetAllWorkFlows, useGetWorkFlowTemplates } from "../../../store/Apis/WorkflowsApi";
import { setAllWorkflows } from "../../../store/one-query/workflowsSlice";
import WorkflowTemplates from "../Components/WorkflowTemplates";

const Workflows = () => {
    const {workflowId}=useParams<{ workflowId: string }>();
    const minimizeSidebarWorkflow=useAppSelector((s)=>s.workflows.minimizeSidebarWorkflow)
    const {data:workflowsData}=useGetAllWorkFlows();
    const [selectedAppOrder, setSelectedAppOrder] = useState<number>(1);
    const dispatch=useAppDispatch();
    const { data: workflowTemplates } = useGetWorkFlowTemplates();

    useEffect(() => {
         if(workflowsData) dispatch(setAllWorkflows(workflowsData))
      }, [workflowsData]);
    
  return (
      <div className="flex-grow-1 container-basic-wokflows mt-2 mb-2">
          <Box className={`workflows-view workflow`}>
            <Box
              className={`left-side workflow-left-side ${
                minimizeSidebarWorkflow ? "minimize-sidebar-workflow" : "maximize-sidebar-workflow"
              }`}
            >
              <WorkflowSidebar
              selectedAppOrder={selectedAppOrder}
              />
            </Box>
            <Box className={` parentWorkflowBody ${
                minimizeSidebarWorkflow ? "minimize-body" : "maximize-body"
              }
              ${
                minimizeSidebarWorkflow ? "workflow-body-full" : "workflow-body-shifted"
              }
              `}
             
              >
             {
              workflowId ? (
                <WorkflowDetails/>
              ) : (
                <div className={`workflows-body workflow-body-start ${
                  !minimizeSidebarWorkflow && "shift-body"
                }`}>
                  <WorkflowTemplates 
                    workflowTemplates={workflowTemplates}
                  />
                </div>
              )
             }
            </Box>
          </Box>
      </div>
  );
};

export default Workflows;
